import { PrismicDocument } from '@prismicio/client';
import { AuthContext } from './prismic';

interface Meta {
  description?: string;
  title?: string;
}

interface IHandle {
  value: string;
  matchLevel: string;
  matchedWords: any[];
}

interface ITitle {
  value: string;
  matchLevel: string;
  matchedWords: any[];
}

interface IBodyHtmlSafe {
  value: string;
  matchLevel: string;
  matchedWords: any[];
}

interface ITag {
  value: string;
  matchLevel: string;
  matchedWords: any[];
}

interface IHighlightResult {
  handle: IHandle;
  title: ITitle;
  body_html_safe: IBodyHtmlSafe;
  _tags: ITag[];
}

export interface ICollectionTag {
  handle: string;
  omsId: string;
  title: string;
  objectID?: string;
  _tags: string[];
}

export enum TCollectionType {
  section = 'section',
  vendor = 'vendor',
  hub = 'hub',
}

export type ICollection = {
  handle: string;
  title: string;
  titleLink?: string;
  body_html: string;
  body_html_safe: string;
  _tags: string[];
  image: string;
  products_count: number;
  updated_at: Date;
  template_suffix?: any;
  meta: Meta;
  objectID: string;
  parent?: string;
  breadcrumb: ICollectionTag[];
  childCollections?: ICollectionTag[];
  _highlightResult: IHighlightResult;
  short_description?: string;
  type: TCollectionType;
};

export interface ICollectionProductBasket {
  products: PrismicDocument[] | null;
  title?: string | null;
  descriptionMobile?: string | null;
}

export interface IMerchCard {
  imageUrl: string;
  targetLink: string;
  imageAlt: string;
  authContext: AuthContext;
  condition?: string | null;
}
